import Box from '@mui/material/Box';
import InputNumber from 'common/components/Elements/Form/InputNumber/InputNumber';
import InputRadioGroup from 'common/components/Elements/Form/InputRadioGroup/InputRadioGroup';
import ModalActions from 'common/components/Elements/Modal/ModalActions/ModalActions';
import SimpleModal from 'common/components/Elements/Modal/SimpleModal/SimpleModal';
import { stringIsNumber, stringTimes } from 'common/utilities/core/string';
import type { ValueLabelOption } from 'core/utilities/core.types';
import React from 'react';
import type { EntitySequence as Sequence,SequenceAlign } from 'sequenceAnalyser/api/sequenceAnalyserApiClient';
import type { HandleAlignedSequencesChange } from 'sequenceAnalyser/components/SequenceAnalyser/SequenceAnalyser';
import type { SequenceSelection } from 'sequenceAnalyser/utilities/selection/selection';
import { insertGapsIntoSelectedSequences } from 'sequenceAnalyser/utilities/selectionActions/selectionActions';

export type InsertPositionValue = 'before' | 'after';

export interface ComponentProps {
  alignedSequences: SequenceAlign[];
  sequences: Sequence[];
  open: boolean;
  onOpen: (open: boolean) => void;
  onAlignedSequencesChange: HandleAlignedSequencesChange;
  selection: SequenceSelection;
}

export function InsertGapsActionModal({
  open, onOpen, alignedSequences, sequences, onAlignedSequencesChange, selection,
}: ComponentProps) {
  const [numberOfGaps, setNumberOfGaps] = React.useState<number | undefined>(1);

  const insertPositions: ValueLabelOption[] = [
    { value: 'before', label: 'Before the selection' },
    { value: 'after', label: 'After the selection' },
  ];

  const [insertPosition, setInsertPosition] = React.useState(insertPositions[1].value);

  return (
    <SimpleModal
      title="Insert gaps"
      open={open}
      onClose={() => {
        onOpen(false);
      }}
      content={(
        <Box mt={1}>
          <InputRadioGroup
            label="Position to insert gaps"
            options={insertPositions}
            onChange={(value) => setInsertPosition(value)}
            value={insertPosition}
            modalLabel
          />
          <InputNumber
            label="Gap size"
            value={(numberOfGaps || '').toString()}
            onChange={((value) => {
              if (stringIsNumber(value) && Number(value) > 0) {
                setNumberOfGaps(Number(value));
              }
            })}
            fullWidth
            required
            modalLabel
          />
          <ModalActions
            applyText="Insert"
            onApply={() => {
              if (selection.positionStart === undefined || selection.positionEnd === undefined || !numberOfGaps) return;

              const position = insertPosition === 'before' ? selection.positionStart : selection.positionEnd + 1;

              const { updatedAlignedSequences, updatedSequences } = insertGapsIntoSelectedSequences(
                selection,
                alignedSequences,
                sequences,
                position,
                stringTimes('.', numberOfGaps),
              );

              onAlignedSequencesChange(updatedAlignedSequences, updatedSequences);

              // Close modal
              onOpen(false);
            }}
          />
        </Box>
      )}
    />
  );
}

export default InsertGapsActionModal;
